import styled from 'styled-components';

export const FooterContainer = styled.div`
  min-height: 50px;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
`;
